import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loader-background" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("main", { class: "loader-main" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rotator-contaainer" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "rotator-logo",
      src: "/logo-circle.svg",
      alt: "circle"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}